export var zh = {
    required: '必填',
    deprecated: '已弃用',
    deprecated_and_sunset_on: '此操作已弃用，将于 ${1} 停止使用。',
    stability_experimental: '实验性',
    stability_alpha: 'Alpha',
    stability_beta: 'Beta',
    copy_to_clipboard: '复制到剪贴板',
    copied: '已复制',
    no_content: '无内容',
    unresolved_reference: '未解析的引用',
    circular_reference: '循环引用',
    read_only: '只读',
    write_only: '只写',
    optional: '可选',
    min: '最小值',
    max: '最大值',
    nullable: '可为 null',
    body: '请求体',
    payload: '有效载荷',
    headers: '头部信息',
    authorizations: '授权',
    responses: '响应',
    path_parameters: '路径参数',
    query_parameters: '查询参数',
    header_parameters: '头参数',
    attributes: '属性',
    test_it: '测试一下',
    information: '信息',
    success: '成功',
    redirect: '重定向',
    error: '错误',
    show: '显示',
    hide: '隐藏',
    available_items: '可用项',
    child_attributes: '子属性',
};
